import { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import LoadingSpinner from '../components/LoadingSpinner';
import { apiGet, apiDownload } from '../api/client';

export default function Dashboard() {
    const [dados, setDados]     = useState(null);
    const [loading, setLoading] = useState(true);
    const hoje = new Date().toISOString().split('T')[0];

    useEffect(() => {
        apiGet('/api/admin/dashboard').then(res => {
            if (res?.success) setDados(res.data);
            setLoading(false);
        });
    }, []);

    const exportar = (formato) => {
        const data = hoje;
        apiDownload(
            `/api/admin/exportar?tipo=agenda&data=${data}&formato=${formato}`,
            `agenda_${data}.${formato}`
        );
    };

    if (loading) return <Layout><LoadingSpinner /></Layout>;

    const cap = dados?.capacidade || {};

    return (
        <Layout>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '28px' }}>
                <div>
                    <h1 style={h1}>Dashboard</h1>
                    <p style={{ color: '#7F8C8D', margin: 0 }}>
                        Hoje — {dados?.data}
                    </p>
                </div>
            </div>

            {/* Cards de status */}
            <div style={grid4}>
                <Card cor="#1B4F72" label="Agendados"   valor={dados?.por_status?.agendado   || 0} />
                <Card cor="#1E8449" label="Confirmados" valor={dados?.por_status?.confirmado  || 0} />
                <Card cor="#566573" label="Retirados"   valor={dados?.por_status?.retirado    || 0} />
                <Card cor="#922B21" label="Cancelados"  valor={dados?.por_status?.cancelado   || 0} />
            </div>

            {/* Capacidade */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', margin: '20px 0' }}>
                <BarraCapacidade
                    tipo="Sucata"
                    usado={cap.sucata?.usado || 0}
                    maximo={cap.sucata?.maximo || 25}
                    percentual={cap.sucata?.percentual || 0}
                />
                <BarraCapacidade
                    tipo="Conservado"
                    usado={cap.conservado?.usado || 0}
                    maximo={cap.conservado?.maximo || 75}
                    percentual={cap.conservado?.percentual || 0}
                />
            </div>

            {/* Próximas retiradas */}
            <div style={card}>
                <h2 style={h2}>Próximas retiradas (3h)</h2>
                {!dados?.proximas?.length ? (
                    <p style={{ color: '#95A5A6' }}>Nenhuma retirada nas próximas 3 horas.</p>
                ) : (
                    <table style={tabelaStyle}>
                        <thead>
                            <tr style={{ background: '#F2F3F4' }}>
                                {['Horário', 'Cliente', 'Tipo', 'Lotes', 'Status'].map(h => (
                                    <th key={h} style={thStyle}>{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {dados.proximas.map(r => (
                                <tr key={r.id} style={{ borderBottom: '1px solid #F0F0F0' }}>
                                    <td style={tdStyle}>{r.hora_inicio} – {r.hora_fim}</td>
                                    <td style={tdStyle}>{r.cliente_nome}</td>
                                    <td style={tdStyle}>{r.tipo_lote}</td>
                                    <td style={tdStyle}>{r.quantidade_lotes}</td>
                                    <td style={tdStyle}>
                                        <StatusChip status={r.status} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </Layout>
    );
}

function Card({ cor, label, valor }) {
    return (
        <div style={{ background: cor, borderRadius: '10px', padding: '20px 24px', color: '#fff' }}>
            <div style={{ fontSize: '32px', fontWeight: '700' }}>{valor}</div>
            <div style={{ fontSize: '13px', opacity: 0.85, marginTop: '4px' }}>{label}</div>
        </div>
    );
}

function BarraCapacidade({ tipo, usado, maximo, percentual }) {
    const cor = percentual >= 90 ? '#922B21' : percentual >= 70 ? '#B7770D' : '#1E8449';
    return (
        <div style={{ ...card, padding: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <span style={{ fontWeight: '600', color: '#2C3E50' }}>{tipo}</span>
                <span style={{ color: '#7F8C8D', fontSize: '13px' }}>{usado} / {maximo} lotes</span>
            </div>
            <div style={{ background: '#EAECEE', borderRadius: '999px', height: '10px', overflow: 'hidden' }}>
                <div style={{
                    width:        `${percentual}%`,
                    height:       '100%',
                    background:   cor,
                    borderRadius: '999px',
                    transition:   'width 0.5s',
                }} />
            </div>
            <div style={{ fontSize: '12px', color: cor, marginTop: '6px', fontWeight: '600' }}>
                {percentual}% utilizado
            </div>
        </div>
    );
}

function StatusChip({ status }) {
    const map = {
        agendado: ['#EBF5FB','#1A5276'],
        confirmado: ['#EAF7EA','#1E8449'],
        retirado: ['#F4F6F7','#566573'],
        cancelado: ['#FDEDEC','#922B21'],
    };
    const [bg, cor] = map[status] || map.agendado;
    return (
        <span style={{ background: bg, color: cor, padding: '2px 8px', borderRadius: '10px', fontSize: '12px', fontWeight: '600' }}>
            {status}
        </span>
    );
}

function BotaoExportar({ onClick, label, secundario }) {
    return (
        <button onClick={onClick} style={{
            padding:      '8px 16px',
            background:   secundario ? '#fff' : '#1B4F72',
            color:        secundario ? '#1B4F72' : '#fff',
            border:       secundario ? '1px solid #1B4F72' : 'none',
            borderRadius: '6px',
            cursor:       'pointer',
            fontSize:     '13px',
            fontWeight:   '600',
        }}>
            {label}
        </button>
    );
}

const h1 = { margin: 0, fontSize: '24px', color: '#1B2631' };
const h2 = { margin: '0 0 16px', fontSize: '16px', color: '#2C3E50' };
const card = { background: '#fff', borderRadius: '10px', padding: '24px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' };
const grid4 = { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '4px' };
const tabelaStyle = { width: '100%', borderCollapse: 'collapse' };
const thStyle = { padding: '10px 12px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#566573', textTransform: 'uppercase' };
const tdStyle = { padding: '10px 12px', fontSize: '14px', color: '#2C3E50' };